import React, { useEffect } from "react";
import { connect } from "react-redux";
import FilterDateReport from "./FilterDateReport";
import HeaderReport from "./HeaderReport";
import CardReport from "./CardReport";
import TabSeparationReport from "./TabSeparationReport";
import ChartReport from "./ChartReport";
import TableReport from "./TableReport";
import reportAction from "../../../store/actions/reportAction";
import eventAdvertise from "../../../store/actions/eventAdvertise";

const ComponentReport = ({
  dateFrom,
  dateTo,
  getReportAllWebSitePublisher,
  getReportAllWebSitePublisherDataChart,
  getReportAllWebSitePublisherDataChartSeparation,
}) => {
  useEffect(() => {
    const eventReport = eventAdvertise.eventAdvertiseString.VIEW;
    getReportAllWebSitePublisher({
      dateFrom,
      dateTo,
    });
    getReportAllWebSitePublisherDataChart({
      dateFrom,
      dateTo,
      eventReport,
    });
    getReportAllWebSitePublisherDataChartSeparation({
      dateFrom,
      dateTo,
    });
  }, []);

  return (
    <>
      <div id="report-top-header-container" className="w-100 bg-secondary">
        <HeaderReport />
        <FilterDateReport />
        <CardReport />
      </div>
      <div
        id="report-chart-and-table-container"
        className="border border-success w-100 rounded my-3"
      >
        <TabSeparationReport />
        <ChartReport />
        <TableReport />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    dateFrom: state.report.date_from,
    dateTo: state.report.date_to,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getReportAllWebSitePublisher: (action) => {
      dispatch({
        type: reportAction.GET_REPORT_ALL_WEB_SITE_PUBLISHER,
        payload: action,
      });
    },
    getReportAllWebSitePublisherDataChart: (action) => {
      dispatch({
        type: reportAction.GET_REPORT_ALL_WEB_SITE_PUBLISHER_DATA_CHART,
        payload: action,
      });
    },
    getReportAllWebSitePublisherDataChartSeparation: (action) => {
      dispatch({
        type: reportAction.GET_ALL_SITE_PUBLISHER_SEPARATION_DATA_CHART,
        payload: action,
      });
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ComponentReport);
